const DOMAINS = ['Fury', 'Calm', 'Mind', 'Body', 'Chaos', 'Order'];

function getCardTypes(card) {
  if (!card) return [];
  const values = Array.isArray(card.types) && card.types.length
    ? card.types
    : [card.type];
  return [...new Set(values.map((type) => String(type || '').trim()).filter(Boolean))];
}

function cardHasType(card, type) {
  const expected = String(type || '').toLowerCase();
  return getCardTypes(card).some((value) => value.toLowerCase() === expected);
}

function getCardDomains(card) {
  if (!card) return [];
  const raw = Array.isArray(card.domains)
    ? card.domains.map((d) => String(d).trim()).filter(Boolean)
    : typeof card.domain === 'string'
    ? card.domain.split(',').map((d) => d.trim()).filter(Boolean)
    : [];
  // 'Colorless' and any other non-standard values are not real Riftbound domains — treat as domainless
  return raw.filter((d) => DOMAINS.includes(d));
}

function getLegendTags(legend) {
  if (!legend || !Array.isArray(legend.tags)) return [];
  return legend.tags.map((t) => String(t).trim()).filter(Boolean);
}

function cardHasChampionTag(card, legendTags) {
  if (!card || !Array.isArray(card.tags) || !legendTags || legendTags.length === 0) return false;
  const lower = card.tags.map((t) => String(t).toLowerCase());
  return legendTags.some((t) => lower.includes(String(t).toLowerCase()));
}

function cardCost(card) {
  const n = Number(card && card.energy);
  return Number.isFinite(n) ? n : 0;
}

function isInDomainIdentity(card, identitySet) {
  const domains = getCardDomains(card);
  if (domains.length === 0) return true; // carte senza dominio sempre ammesse
  return domains.every((d) => identitySet.has(d)); // single -> in; multi -> tutti in
}

module.exports = {
  DOMAINS,
  getCardTypes,
  cardHasType,
  getCardDomains,
  getLegendTags,
  cardHasChampionTag,
  cardCost,
  isInDomainIdentity,
};
